import React from 'react';
import { countryOptions } from '@/utils/data/countryCodes';

import NewSingleSelect from './Select/NewSingleSelect';

interface CountryDropdownProps {
  value: string;
  handleChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
  required?: boolean;
  height?: number;
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  value,
  handleChange,
  placeholder = 'Select Country',
  label = 'Country',
  className = '',
  required = true,
  height = 200,
}) => {
  return (
    <NewSingleSelect
      options={countryOptions}
      value={value}
      onSelect={(v) => handleChange(v as string)}
      placeholder={placeholder}
      label={label}
      required={required}
      wrapperClassName={`w-full ${className}`}
      height={height}
    />
  );
};

export default CountryDropdown;
